import React, { useState, useEffect,useRef } from 'react';
import API from '../../../utils/API';
import { FormattedMessage, useIntl } from 'react-intl';
import TrashIcon from '../../../assets/icons/table/trash.svg';
import './UserModals.css';

function ImportModal(props) {
  const {
    setResetImportModalRef,
    setSuccess,
    modalError, setModalError,
    ImportLoadData,
    closeModal,
  } = props;

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [failingRows, setFailingRows] = useState([]);
  const [successfulRows, setSuccessfulRows] = useState([]);
  const [duplicateRows, setDuplicateRows] = useState([]);
  const fileInputRef = useRef(null);
  const modalBodyRef = useRef(null);

  const intl = useIntl();

  const chooseFileText = intl.formatMessage({ id: 'MES_CHOOSE_FILE_TEXT' });

  useEffect(() => {
    setResetImportModalRef(resetModal);
  }, [setResetImportModalRef]);

  const resetModal = () => {
    setDuplicateRows([]);
    setFailingRows([]);
    setSuccessfulRows([]);
    setSelectedFile(null);
    setFileName('');
    setModalError('');
    fileInputRef.current.value = null;
  };

  function handleFileSelection(file) {
    if (file === undefined) return;
    setSelectedFile(file);
    setFileName(file.name);
  }

  function removeFile(e) {
    e.stopPropagation();
    setSelectedFile(null);
    setFileName('');
    setModalError('');
    fileInputRef.current.value = null;
  }

  function openFileDialog(e) {
    e.stopPropagation();
    document.getElementById('userFormFile').click();
  }

  function handleUpload() {
    if (selectedFile) {
      const fileName = selectedFile.name;
      const fileExtension = fileName.split('.').pop().toLowerCase();

      if (fileExtension === 'csv') {
        API.importSignageUsers(selectedFile)
          .then((res) => {
            setFailingRows(res.data.failingRows);
            setSuccessfulRows(res.data.successfulRows);
            setDuplicateRows(res.data.duplicateRows);
            ImportLoadData();
            resetModal();
            closeModal("signagePlusImportUsersModal");
            setSuccess(
              <FormattedMessage
                id="IMPORT_USERS_SUCCESS"
                values={{
                  successfulCount: res.data.successfulRows.length,
                  failingCount: res.data.failingRows.length,
                  duplicateCount: res.data.duplicateRows.length
                }}
              />
            );
          })
          .catch((err) => {
            setModalError(<FormattedMessage id="IMPORT_USERS_FAILED" />);
            console.error(err);
          });
      } else {
        setModalError(<FormattedMessage id="INVALID_FILE_EXTENSION" values={{ extension: fileExtension }} />);
      }
    } else {
      setModalError(<FormattedMessage id="PLEASE_SELECT_FILE" />);
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFileSelection(file);
  }

  useEffect(() => {
    if (modalError && modalBodyRef.current) {
      modalBodyRef.current.scrollTop = modalBodyRef.current.scrollHeight;
    }
  }, [modalError]);

  return (
    <div className="modal modal-mse fade" id="signagePlusImportUsersModal" tabIndex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-mes-content">
          <div className="modal-header modal-mes-header" style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title modal-mes-title"><FormattedMessage id="IMPORT_USERS" /></h5>
            <button id="closeImportModal" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body" ref={modalBodyRef}>
            <div className="modal-subtitle modal-mes-subtitle fw-500"><FormattedMessage id="UPLOAD_A_CSV" /></div>
            <div className={`mb-3 drop-zone fw-normal ${selectedFile ? 'active' : ''}`}
              onClick={() => document.getElementById('userFormFile').click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(handleDrop)}>
              {selectedFile ? (
                <div className="file-info">
                  <div className="file-details">
                    <span className="file-name">{fileName}</span>
                    <span className="file-size">{(selectedFile.size / 1024).toFixed(2)} KB</span>
                  </div>
                  <img id="removeBtn" src={TrashIcon} alt="Trash Icon" onClick={removeFile} className="trash-icon" />
                </div>
              ) : (
                <div className='color-grey text-center' style={{ textAlign: 'center' }}>
                  <FormattedMessage
                    id="MES_DRAG_AND_DROP_OR_CHOOSE_FILE"
                    values={{
                      chooseFile: (
                        <span
                          className="custom-underline lh-18 fz-16 fw-semibold"
                          onClick={openFileDialog}
                        >
                          {chooseFileText}
                        </span>
                      ),
                      br: <br />
                    }}
                  />
                </div>
              )}
              <input className="form-control" type="file" ref={fileInputRef} id="userFormFile" onChange={(e) => handleFileSelection(e.target.files[0])} style={{ display: 'none' }} />
            </div>
            <div className="csv-template mb-3">
              <div className="template-details text-start">
                <div className="template-title modal-mes-subtitle fw-500 ml-2"><FormattedMessage id="CSV_TEMPLATE" /></div>
                <div className="template-description color-grey  fw-normal lh-18 ml-2"><FormattedMessage id="CSV_TEMPLATE_DESCRIPTION" /></div>
                <div className="template-link">
                  <a id="downloadBtn" className="custom-underline mes-from-label-1 fw-semibold lh-18 ml-2" href="/templates/usersTemplate.csv" download="template.csv"><FormattedMessage id="DOWNLOAD" /></a>
                </div>
              </div>
            </div>
            {modalError && (
              <div className="modal-error invalid-feedback d-block fw-bold text-center">
                {modalError}
              </div>
            )}
          </div>
          <div className="modal-footer modal-mes-footer d-flex align-items-center">
            <button id="backBtn" type="button" className="btn btn-outline-secondary me-3" data-bs-dismiss="modal"><FormattedMessage id="CLOSE" /></button>
            <button id="importUsersBtn" type="button" className="btn btn-primary but-darkblue" onClick={handleUpload}><FormattedMessage id="IMPORT" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportModal;